import { render, staticRenderFns } from "./WorkflowRelease.vue?vue&type=template&id=7ddeda88&scoped=true"
import script from "./WorkflowRelease.vue?vue&type=script&lang=js"
export * from "./WorkflowRelease.vue?vue&type=script&lang=js"
import style0 from "./WorkflowRelease.vue?vue&type=style&index=0&id=7ddeda88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddeda88",
  null
  
)

export default component.exports